import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { MatCheckboxChange, MatDialogRef, MatSelectChange, MatSnackBar } from '@angular/material';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { BusinessAdminNotesService } from '../services/businessAdminNotes.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';
import { AirportService } from '../../airport/airport.service';
var AdminBusinessComponent = /** @class */ (function () {
    function AdminBusinessComponent(dialogRef, data, _businessService, _adminNotesService, _tagService, _airportService, router, _snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._businessService = _businessService;
        this._adminNotesService = _adminNotesService;
        this._tagService = _tagService;
        this._airportService = _airportService;
        this.router = router;
        this._snackBar = _snackBar;
        this.hasTag = hasTag;
        this.model = {};
        this.adminDeleteConfirmationArray = [];
        this.businessNotesToDelete = [];
        this.lastUpdateDate = null;
        this.lastUpdateBy = '';
        this.lastVerifiedDate = null;
        this.lastVerifiedBy = '';
        this.lastFeeUpdateDate = null;
        this.lastFeeUpdateBy = '';
        this.isFlightDeckAdmin = false;
        this.isRegionalManager = false;
        this.isFlightSchool = false;
        this.availableDateRanges = [];
        this.business = data.business;
        for (var i = 0; i < this.business.admins.length; i++) {
            this.adminDeleteConfirmationArray.push(false);
        }
    }
    AdminBusinessComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, i, lastUpdateName, lastVerifiedName, lastFeeUpdateName, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            return tslib_1.__generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessService.isRegionalManager()];
                    case 1:
                        _b = (_r.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_r.sent());
                        _r.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        _c = this;
                        return [4 /*yield*/, this._businessService.isFlightDeckAdmin()];
                    case 4:
                        _c.isFlightDeckAdmin = _r.sent();
                        this.isFlightSchool = (!this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training::Private'); })
                            && this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training'); }));
                        if (!(!this.isRegionalManager && !this.notesArray)) return [3 /*break*/, 6];
                        _d = this;
                        return [4 /*yield*/, this._adminNotesService.getBusinessAdminNotes(this.business.id)];
                    case 5:
                        _d.notesArray = _r.sent();
                        _r.label = 6;
                    case 6:
                        if (!(!this.datesArray && this.isFlightDeckAdmin)) return [3 /*break*/, 8];
                        _e = this;
                        return [4 /*yield*/, this._adminNotesService.getBusinessAdminDates(this.business.id)];
                    case 7:
                        _e.datesArray = _r.sent();
                        for (i = 0; i < this.datesArray.length; i++) {
                            if (this.datesArray[i].note.startsWith('__LastUpdate')) {
                                this.lastUpdateDate = this.datesArray[i].updateDate.toLocaleString('en-US');
                                lastUpdateName = this.datesArray[i].note.match(/__LastUpdate -  (.*)/);
                                if (lastUpdateName.length > 1) {
                                    this.lastUpdateBy = this.datesArray[i].updateBy + ' (' + lastUpdateName[1] + ')';
                                }
                                else {
                                    this.lastUpdateBy = this.datesArray[i].updateBy;
                                }
                            }
                            if (this.datesArray[i].note.startsWith('__LastVerified')) {
                                this.lastVerifiedDate = this.datesArray[i].updateDate.toLocaleString('en-US');
                                lastVerifiedName = this.datesArray[i].note.match(/__LastVerified - (.*)/);
                                if (lastVerifiedName.length > 1) {
                                    this.lastVerifiedBy = this.datesArray[i].updateBy + ' (' + lastVerifiedName[1] + ')';
                                }
                                else {
                                    this.lastVerifiedBy = this.datesArray[i].updateBy;
                                }
                            }
                            if (this.datesArray[i].note.startsWith('__LastFees')) {
                                this.lastFeeUpdateDate = this.datesArray[i].updateDate.toLocaleString('en-US');
                                lastFeeUpdateName = this.datesArray[i].note.match(/__LastFees -  (.*)/);
                                if (lastFeeUpdateName.length > 1) {
                                    this.lastFeeUpdateBy = this.datesArray[i].updateBy + ' (' + lastFeeUpdateName[1] + ')';
                                }
                                else {
                                    this.lastFeeUpdateBy = this.datesArray[i].updateBy;
                                }
                            }
                        }
                        _r.label = 8;
                    case 8:
                        this.setNotesDataSource();
                        _f = this;
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 9:
                        _f.allTags = _r.sent();
                        _g = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Magazine::Bulk Distribution')];
                    case 10:
                        _g.FTMagTag = _r.sent();
                        this.getsFTMagazine = hasTag(this.business.tags, 'Magazine::Bulk Distribution');
                        _h = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Flying Club')];
                    case 11:
                        _h.FlyingClubTag = _r.sent();
                        this.isFlyingClub = hasTag(this.business.tags, 'Flying Club');
                        _j = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::BusinessIsFbo')];
                    case 12:
                        _j.FboTag = _r.sent();
                        this.isFbo = hasTag(this.business.tags, 'Admin::BusinessIsFbo');
                        _k = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::HideBusiness')];
                    case 13:
                        _k.HideBusinessTag = _r.sent();
                        _l = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::OffersTransparentPricing')];
                    case 14:
                        _l.OffersTransparentPricingTag = _r.sent();
                        this.offersTransparentPricing = hasTag(this.business.tags, 'Admin::OffersTransparentPricing');
                        _m = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::AftaSchool')];
                    case 15:
                        _m.AftaSchoolTag = _r.sent();
                        this.isAftaSchool = hasTag(this.business.tags, 'Admin::AftaSchool');
                        _o = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::BusinessNotApproved')];
                    case 16:
                        _o.NotApprovedTag = _r.sent();
                        this.availableDateRanges = this.getAwardTagDateRanges();
                        _p = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::Flight Training::Display Customer Feedback Report')];
                    case 17:
                        _p.DisplayCustomerFeedbackReportTag = _r.sent();
                        _q = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Admin::Flight Training::Display Prior Year Badges')];
                    case 18:
                        _q.DisplayPriorYearTags = _r.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onAddNote = function (noteForm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var addedNote, _a, e_1, error;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this._adminNotesService.createBusinessAdminNote(this.business.id, noteForm.value.note)];
                    case 1:
                        addedNote = _b.sent();
                        if (!addedNote) return [3 /*break*/, 3];
                        noteForm.controls['note'].setValue('');
                        noteForm.form.markAsPristine();
                        noteForm.form.markAsUntouched();
                        _a = this;
                        return [4 /*yield*/, this._adminNotesService.getBusinessAdminNotes(this.business.id)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Add Business Note Failed: ' + addedNote, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        error = e_1;
                        this._snackBar.open('Add Business Note Failed: ' + error.message, 'Close', {
                            duration: 5000
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onSaveNote = function (modifiedNote) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var updatedNote, _a, e_2, error;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, this._adminNotesService.updateBusinessAdminNote(this.business.id, modifiedNote.businessAdminNotesId, modifiedNote.note)];
                    case 1:
                        updatedNote = _b.sent();
                        if (!updatedNote) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this._adminNotesService.getBusinessAdminNotes(this.business.id)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Updating Business Note Failed: ' + updatedNote, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        error = e_2;
                        this._snackBar.open('Updating Business Note Failed: ' + error.message, 'Close', {
                            duration: 5000
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onDeleteNote = function (noteToDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.businessNotesToDelete.push(noteToDelete);
                return [2 /*return*/];
            });
        });
    };
    AdminBusinessComponent.prototype.deleteNote = function (confirmation, note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deletedNote, _a, index;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!confirmation) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._adminNotesService.deleteBusinessAdminNote(this.business.id, note.businessAdminNotesId)];
                    case 1:
                        deletedNote = _b.sent();
                        if (!deletedNote) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this._adminNotesService.getBusinessAdminNotes(this.business.id)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        _b.label = 3;
                    case 3:
                        index = this.businessNotesToDelete.indexOf(note, 0);
                        this.businessNotesToDelete.splice(index, 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.shouldDisplayDeleteButtons = function (notesForDeletion, note) {
        return notesForDeletion && notesForDeletion.length > 0 &&
            notesForDeletion.findIndex(function (n) { return n.businessAdminNotesId === note.businessAdminNotesId; }) !== -1;
    };
    AdminBusinessComponent.prototype.onKeyUp = function () {
        this.model.recid = this.model.recid.replace(/\D/g, '');
    };
    AdminBusinessComponent.prototype.setNotesDataSource = function () {
        this.dataSource = new MatTableDataSource(this.notesArray);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    AdminBusinessComponent.prototype.applyFilter = function (filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    };
    AdminBusinessComponent.prototype.isChecked = function (tagId) {
        var TAGS = this.business.tags;
        for (var _i = 0, TAGS_1 = TAGS; _i < TAGS_1.length; _i++) {
            var tag = TAGS_1[_i];
            if (tag.tagId === tagId) {
                return true;
            }
        }
        return false;
    };
    AdminBusinessComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, TAG_ID, BUSINESS_ID, newBusiness, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        TAG_ID = +event.source.id;
                        BUSINESS_ID = this.business.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, , 9]);
                        if (!event.source.checked) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postTag(TAG_ID, BUSINESS_ID)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.deleteTag(TAG_ID, BUSINESS_ID)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!!this.isRegionalManager) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._businessService.updateBusiness(this.business)];
                    case 6:
                        newBusiness = _a.sent();
                        Object.assign(this.business, newBusiness);
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_3 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_3;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onChangeFlyingClubType = function (clubType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tagList, newTag, networkClub, proposedClub, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tagList = this.allTags, newTag = this._tagService.findTagByName(tagList, clubType), networkClub = this._tagService.findTagByName(tagList, 'Flying Club::AOPA::AOPA Network'), proposedClub = this._tagService.findTagByName(tagList, 'Flying Club::AOPA::Proposed Club');
                        if (!hasTag(this.business.tags, networkClub.tagName)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tagService.deleteTag(networkClub.tagId, this.business.id)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!hasTag(this.business.tags, proposedClub.tagName)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._tagService.deleteTag(proposedClub.tagId, this.business.id)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!(clubType !== '')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._tagService.postTag(newTag.tagId, this.business.id)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 7:
                        _a.business = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onAddAdmin = function (addForm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var added, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._businessService.addBusinessAdmin(this.business, this.model.recid)];
                    case 1:
                        added = _b.sent();
                        if (!(added && added === 'SUCCESS')) return [3 /*break*/, 3];
                        this.model.recid = '';
                        addForm.form.markAsPristine();
                        addForm.form.markAsUntouched();
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 2:
                        _a.business = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Add Admin Failed: ' + added, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onDeleteAdmin = function (index) {
        if (this.adminDeleteConfirmationArray[index]) {
            this.adminDeleteConfirmationArray[index] = false;
            return;
        }
        this.adminDeleteConfirmationArray[index] = true;
    };
    AdminBusinessComponent.prototype.onDeleteConfirm = function (recid, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deleted, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._businessService.deleteBusinessAdmin(this.business, recid)];
                    case 1:
                        deleted = _b.sent();
                        if (!(deleted && deleted === 'SUCCESS')) return [3 /*break*/, 3];
                        this.adminDeleteConfirmationArray[index] = false;
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 2:
                        _a.business = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Delete Admin Failed: ' + deleted, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.onDelete = function (deleteText, deleteReason) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var addedNote, deleted;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (deleteText.toLocaleLowerCase() !== 'delete'.toLocaleLowerCase()) {
                            this._snackBar.open('You must type "Delete" to verify you want to delete this business', 'Close', {
                                duration: 8000
                            });
                            return [2 /*return*/];
                        }
                        if (deleteReason.length < 1 || deleteReason.length > 1024) {
                            this._snackBar.open('You must provide a reason the business is being deleted', 'Close', {
                                duration: 8000
                            });
                            return [2 /*return*/];
                        }
                        if (!(deleteText.toLocaleLowerCase() === 'delete'.toLocaleLowerCase())) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._adminNotesService.createBusinessAdminNote(this.business.id, deleteReason)];
                    case 1:
                        addedNote = _a.sent();
                        return [4 /*yield*/, this._businessService.deleteBusiness(this.business)];
                    case 2:
                        deleted = _a.sent();
                        if (deleted) {
                            this.dialogRef.close();
                            if (this.business.airports.length > 0) {
                                this.router.navigate(['/airports', this.business.airports[0].identifier]);
                                window.location.reload(true);
                            }
                            else {
                                this.router.navigate(['/search']);
                            }
                        }
                        else {
                            this._snackBar.open('Delete Failed', 'Close', {
                                duration: 2000
                            });
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.pocCheckBoxChanged = function (event, recid, fboFeePoc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._businessService.updateBusinessAdmin(this.business, recid, event.source.checked, fboFeePoc)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.feePocCheckBoxChanged = function (event, recid, primaryPoc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._businessService.updateBusinessAdmin(this.business, recid, primaryPoc, event.source.checked)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.regionalBadgeSelected = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR_MSG, BUSINESS_ID, allBusinessTags, previousTag, TAG_ID, index, TAG_ID_1, e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        BUSINESS_ID = this.business.id;
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allBusinessTags = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 8, , 9]);
                        if (!(this.selectedRegionalBadgeId === '0')) return [3 /*break*/, 5];
                        previousTag = this.getRegionalTagAssignedToBusiness();
                        if (!(previousTag != null && hasTag(this.business.tags, previousTag.tagName))) return [3 /*break*/, 4];
                        TAG_ID = previousTag.tagId;
                        return [4 /*yield*/, this._tagService.deleteTag(TAG_ID, BUSINESS_ID)];
                    case 3:
                        _a.sent();
                        index = this.business.tags.map(function (t) { return t.tagId; }).indexOf(TAG_ID);
                        if (index > -1) {
                            this.business.tags.splice(index, 1);
                        }
                        _a.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        TAG_ID_1 = this.selectedRegionalBadgeId;
                        return [4 /*yield*/, this._tagService.postTag(TAG_ID_1, BUSINESS_ID)];
                    case 6:
                        _a.sent();
                        // add to business tags to keep in sync
                        this.business.tags.push(allBusinessTags.find(function (t) { return t.tagId === TAG_ID_1; }));
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_6 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_6;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    AdminBusinessComponent.prototype.dateRangeSelected = function (event) {
        this.selectedDateRange = event.value;
        this.activeFTEAwardTags = this.getActiveFTEAwardTags(this.selectedDateRange);
        this.NationalWinnerTag = this.activeFTEAwardTags.find(function (t) { return t.tagName.includes(' National'); });
        this.DistinguishedSchoolTag = this.activeFTEAwardTags.find(function (t) { return t.tagName.includes('Distinguished Flight School'); });
        this.activeRegionalTags = this.activeFTEAwardTags.filter(function (t) { return t.tagName.includes('Region'); });
        var regionalAwardTag = this.getRegionalTagAssignedToBusiness();
        this.selectedRegionalBadgeId = regionalAwardTag != null ? regionalAwardTag.tagId : '';
    };
    AdminBusinessComponent.prototype.getRegionalTagAssignedToBusiness = function () {
        var _this = this;
        var activeTagsAssignedToBusiness = this.business.tags.filter(function (bt) { return _this.activeFTEAwardTags.find(function (t) { return t.tagId === bt.tagId; }); });
        var regionalAwardTag;
        if (activeTagsAssignedToBusiness != null && activeTagsAssignedToBusiness.length > 0) {
            regionalAwardTag = activeTagsAssignedToBusiness.find(function (t) { return t.tagName.includes('Region'); });
        }
        return regionalAwardTag;
    };
    AdminBusinessComponent.prototype.getAwardTagDateRanges = function () {
        var toReturn = [];
        var datesToExclude = ['2012', '2013', '2014', '2015', '2016', '2017'];
        var re = /Awards::Flight Training::(?<dateRange>\d{4}-?\d{0,2}) /;
        var awardTags = this._tagService.searchTagsByName(this.allTags, 'Awards::Flight Training::');
        for (var _i = 0, awardTags_1 = awardTags; _i < awardTags_1.length; _i++) {
            var awardTag = awardTags_1[_i];
            var match = awardTag.tagName.match(re);
            if (match != null && match[1] != null && !toReturn.includes(match[1]) && !datesToExclude.includes(match[1])) {
                toReturn.push(match[1]);
            }
        }
        return toReturn;
    };
    AdminBusinessComponent.prototype.formatTagName = function (tagName) {
        var formattedName = '';
        var re = /Awards::Flight Training::\d{4}-?\d{0,2}\D+- (?<regionName>\D+) Region/;
        var match = tagName.match(re);
        if (match != null && match[1] != null) {
            formattedName = match[1];
        }
        else {
            re = /Awards::Flight Training::\d{4}-?\d{0,2}\ Regional Best - (?<regionName>\D+)/;
            match = tagName.match(re);
            if (match != null && match[1] != null) {
                formattedName = match[1];
            }
        }
        return formattedName;
    };
    AdminBusinessComponent.prototype.getActiveFTEAwardTags = function (range) {
        var activeTags = this._tagService.searchTagsByName(this.allTags, 'Awards::Flight Training::' + range);
        // should never happen but if somehow does not find any matches, return empty array.
        if (activeTags.length === 0) {
            activeTags = [];
        }
        return activeTags;
    };
    return AdminBusinessComponent;
}());
export { AdminBusinessComponent };
